<template>
  <div class="about">
    <h1>This is an about page</h1>
    <p>You can put information about your project here.</p>
  </div>
</template>

<script>
export default {
  name: 'AboutView'
}
</script>
